import { type Appointment } from 'types/appointments';
import { formatUnifiedForDisplay } from 'utils/date';

export const getLastSessionDisplay = (appointments: Appointment[]): string | undefined => {
  let latestAppointment: Appointment | undefined;

  for (const appointment of appointments) {
    if (appointment.canceled || !appointment.dateTime) continue;
    if (!latestAppointment || appointment.dateTime > latestAppointment.dateTime) {
      latestAppointment = appointment;
    }
  }

  if (!latestAppointment?.dateTime) return undefined;

  return formatUnifiedForDisplay(latestAppointment.dateTime);
};
